import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentTableData } from 'projects/apna-lib/src/lib/formly-components/formly-document-table/formly-document-table.component';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';

export interface UploadDocumentData {
  model: any,
  documentOptions: any[]
}

@Component({
  selector: 'fa-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss']
})
export class UploadFormComponent implements OnInit {
  @Input() data: UploadDocumentData;
  @Input() mobileConfig: any;
  @Output() documentUploaded = new EventEmitter<number>();
  @ViewChild("openUploadPopup") openUploadPopup;
  @ViewChild('openCongratulationPopup') openCongratulationPopup
  layout: FormlyFieldConfig[];
  mobileDocLayout: FormlyFieldConfig[];
  sampleImageUrl: string;
  documentSamples = this.configService.getConfig1("foreignAdmits", "documentSampleImages");
  loanWidgetConfig = this.configService.getConfig1("loanWidgetConfig")
  isPartnerLink: boolean = false;
  partnerLogo: string;
  documentData: any;
  categoryData: any;
  dataModel: string = "user-documents";
  uploadedDocs: string[] = [];
  congratulationUploadDocs: boolean = false;
  headingList = this.loanWidgetConfig.uploadDocumentHeadingList;
  constructor(
    private configService: ConfigService,
    private route: Router,
    private loanService: LoanGtmService,
    private apiHelper: ApiHelperService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');

    if (puid) {
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }

    }
    this.dataPreprocessor(false);
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  setSampleImageUrl(documentName: string) {
    this.layout = undefined;
    this.sampleImageUrl = this.documentSamples[documentName];
    setTimeout(() => {
      if (this.mobileConfig) {
        this.setMobileLayout()
      }
      else {
        this.setLayout();

      }
    }, 200)
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row mx-3 p-3 mb-0 border border-custom-gray rounded-custom",
        fieldGroup: [
          {
            className: "",
            key: "documentName",
            type: "radio",
            templateOptions: {
              required: true,
              showDocLayout: true,
              options: this.data?.documentOptions,
              startIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715603989449document-text.png",
              endIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715604007571export.png",
              checkedIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715668464674Listed%20Icon.png",
              editIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715668702802edit-2.png",
              attributes: {
                labelClassName: "mb-1 text-center",
                checkedValues: JSON.stringify(this.uploadedDocs)
              },
              click: (field, event) => {
                event.stopPropagation();
                setTimeout(() => {
                  this.data.model.file = undefined;
                  this.openModal();
                  this.setSampleImageUrl(this.data?.model?.documentName);
                }, 100)
              }
            }
          },
        ]
      },


    ]
  }
  setMobileLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12 col-md-5 px-5",
            key: "documentName",
            type: "radio",
            templateOptions: {
              required: true,
              options: this.data?.documentOptions,
              startIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715603989449document-text.png",
              endIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715604007571export.png",
              checkedIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715668464674Listed%20Icon.png",
              editIcon: "https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715668702802edit-2.png",
              attributes: {
                labelClassName: "mb-2",
                checkedValues: JSON.stringify(this.uploadedDocs)
              },
              click: (field, event) => {
                event.stopPropagation();
                setTimeout(() => {
                  this.data.model.file = undefined;
                  this.openModal();
                  this.setSampleImageUrl(this.data?.model?.documentName);
                }, 100)
              }
            }
          },
        ]
      },


    ]
  }
  openModal() {
    const options: NgbModalOptions = {
      windowClass: 'modal-bottom',
      keyboard: false,
      backdrop: "static",
      animation: true
    };
    this.setDocLayout();
    this.modalService.open(this.openUploadPopup, options)
  }

  setDocLayout() {
    this.mobileDocLayout = [
      {
        className: "col-12 col-md-7",
        fieldGroupClassName: "row mx-1",
        fieldGroup: [
          {
            className: "col-12 mb-3",
            key: 'file',
            type: 'files',
            templateOptions: {
              hideDeleteDownloadButton: false,
              hideRequiredMarker: true,
              hideLabel: true,
              required: true,
              placeholder: "Upload Document",
              showPlaceHolderIcon: false,
              isMobileConfig: true,
              mobileConfigClass: "bg-primary-apply text-light rounded-custom",
              attributes: {
                multiple: "multiple",
              },

            },
            expressionProperties: {
              "templateOptions.placeholder": (model: any) => {
                if (this.data?.model?.fileData && this.data?.model?.fileData[this.data?.model?.documentName]?.filePath?.length > 0) {
                  return "Replace Document"
                }
                else {
                  return "Upload Document"
                }
              },
              "templateOptions.mobileConfigClass": (model: any) => {
                if (this.data?.model?.fileData && this.data?.model?.fileData[this.data?.model?.documentName]?.filePath?.length > 0) {
                  return "btn btn-outline-primary text-primary fw-bold bg-white rounded-custom py-2"
                }
                else {
                  return "bg-primary-apply text-light rounded-custom py-3 fw-bold"
                }
              }
            }
          },


          {
            className: "col-12 col-md-12",
            type: "button",
            templateOptions: {
              btnType: 'primary w-100 text-light rounded-custom p-2 mb-3',
              text: "Save",
              type: "submit",
              onClick: () => {
                setTimeout(() => {
                  this.modalService.dismissAll();
                }, 200);
                if (this.data?.model?.category === undefined || this.data?.model?.documentName === undefined || this.data?.model?.file === undefined) {
                  this.data.model["error"] = "Hello world"
                }
              },

            },
            hideExpression: () => {
              if (this.data?.model?.file?.length > 0) return false;
              else return true;
            }
          },
        ]

      }
    ]
  }
  dataPreprocessor(ev: boolean) {
    this.layout = undefined;
    if (this.activatedRoute?.snapshot?.queryParams?.hasOwnProperty("referenceId") && this.activatedRoute.snapshot?.queryParams?.hasOwnProperty("token")) {
      const referenceId = this.activatedRoute?.snapshot?.queryParams?.referenceId;
      const token = this.activatedRoute.snapshot.queryParams.token;
      localStorage.setItem("token", token);
      localStorage.setItem("userId", referenceId);
      localStorage.setItem("ttl", "3600")
      this.apiHelper.getDataById(this.dataModel, referenceId).subscribe((data: any) => {
        if (ev) {
          if (Object.keys(data?.academicDocuments || [])?.length + Object.keys(data?.studentKYCDocuments || [])?.length + Object.keys(data?.coapplicantsDocuments || [])?.length + Object.keys(data?.financialDocuments || [])?.length >= 23) {
            this.modalService.open(this.openCongratulationPopup, {
              centered: true,
              size: 'l'
            })
          }
        }
        delete data?.created;
        delete data?.modified;
        this.documentData = data;
        sessionStorage.setItem("documentCount", JSON.stringify(data?.totalDocuments))
        this.data.model["id"] = this.documentData?.id;
        this.data.model["fileData"] = { ...this.documentData[this.data?.model?.category] }
        this.checkUploadedDocuments(this.data?.model?.category);
        this.categoryData = { ...this.documentData[this.data?.model?.category] };
      },
        (err: any) => {
          this.documentData = {};
          if (this.mobileConfig) {
            this.setMobileLayout()
          }
          else {
            this.setLayout();

          }
          console.log(err)
        }
      )
    }
    else {
      this.apiHelper.getDataById(this.dataModel, this.loanService.studentDetails.id).subscribe((data: any) => {
        if (ev) {
          if (Object.keys(data?.academicDocuments || [])?.length + Object.keys(data?.studentKYCDocuments || [])?.length + Object.keys(data?.coapplicantsDocuments || [])?.length + Object.keys(data?.financialDocuments || [])?.length >= 23) {
            this.modalService.open(this.openCongratulationPopup, {
              centered: true,
              size: 'l'
            })
          }
        }
        delete data?.created;
        delete data?.modified;
        this.documentData = data;
        this.data.model["id"] = this.documentData?.id;
        this.data.model["fileData"] = { ...this.documentData[this.data?.model?.category] }
        this.checkUploadedDocuments(this.data?.model?.category);
        sessionStorage.setItem("documentCount", JSON.stringify(data?.totalDocuments))
        this.categoryData = { ...this.documentData[this.data?.model?.category] };
      },
        (err: any) => {
          this.documentData = {};
          if (this.mobileConfig) {
            this.setMobileLayout()
          }
          else {
            this.setLayout();

          }
          console.log(err)
        }
      )
    }
  }

  dataProcessor(data: any) {
    let rqdObj: any = {};

    if (data?.error) {
      delete data?.error;
      this.data.model.error = undefined;
    }

    if (data) {
      rqdObj = this.setUploadObject(data)
      rqdObj["userId"] = this.loanService.studentDetails.id;
      if (this.documentData && this.documentData[data?.category]) {
        rqdObj[data?.category] = Object.assign(this.documentData[data?.category], rqdObj[data?.category])
      }
      data = { ...rqdObj };
    }
    if (this.documentData?.id) {
      data["id"] = this.documentData?.id;
    }

    this.checkUploadedDocuments(data?.category, rqdObj);
    return data;
  }

  checkUploadedDocuments(category: string, data?: any) {
    if (this.documentData && Object.keys(this.documentData)?.length > 0 && this.documentData[category]) {
      let checkCategory = this.documentData[category];
      Object.keys(checkCategory).forEach((single: string) => {
        if (checkCategory[single]?.filePath?.length > 0) {
          this.uploadedDocs.push(single)
        }
      })
    }
    this.data?.documentOptions.forEach((single: any) => {
      if (this.uploadedDocs?.includes(single?.value) || this.data?.model.documentName?.includes(single?.value)) {
        single["isChecked"] = true;
      }
      if (!this.uploadedDocs?.includes(single?.value) && this.data?.model.documentName?.includes(single?.value)) {
        this.uploadedDocs?.push(this.data?.model.documentName)
      }
    })
    if (this.mobileConfig) {
      if (data) {
        this.layout = undefined;
        let newModel = { ...this.data.model }
        this.data.model = undefined
        setTimeout(() => {
          this.data.model = { ...newModel }
          this.data.model["fileData"] = {}
          this.data.model.fileData = Object.assign(this.data?.model?.fileData, { ...data[this.data.model.category] })
        }, 100)
      }
      this.setMobileLayout()
    }
    else {
      if (data) {
        this.layout = undefined;
        let newModel = { ...this.data.model }
        this.data.model = undefined
        setTimeout(() => {
          this.data.model = { ...newModel }
          this.data.model["fileData"] = {}
          this.data.model.fileData = Object.assign(this.data?.model?.fileData, { ...data[this.data.model.category] })
        }, 100)
      }
      this.setLayout();

    }
    this.documentUploaded.emit(this.uploadedDocs.length);
  }

  setUploadObject(data) {
    let rqdObj: any = {};
    if (this.documentData[data?.category]) {
      if (this.documentData[data?.category][data?.documentName]) {
        rqdObj[data?.category] = {
          [data?.documentName]: { ...this.documentData[data?.category][data?.documentName] },
        }
        rqdObj[data?.category][data?.documentName]?.filePath.push(...data?.file);
        rqdObj[data?.category][data?.documentName]["uploadedById"] = this.loanService.studentDetails.id;
      }
      else {
        rqdObj[data?.category] = {
          [data?.documentName]: {
            "filePath": [...data.file],
            "uploadedById": this.loanService.studentDetails.id
          }
        }
      }
    }
    else {
      rqdObj[data?.category] = {
        [data?.documentName]: {
          "filePath": [...data.file],
          "uploadedById": this.loanService.studentDetails.id
        }
      }
    }


    return rqdObj;
  }

  onSubmitResponse(ev: any) {
    if (!ev?.error) {
      this.uploadedDocs = [];
      this.data.model.documentName = undefined;
      this.data.model.file = undefined;
      this.dataPreprocessor(true);
    }
  }

  deleteDocument(url: string) {
    let documentData = this.categoryData[this.data?.model?.documentName]

    if (documentData && documentData?.filePath?.length > 0) {
      documentData.filePath = documentData?.filePath?.filter((single: string) => single !== url);
    }

    let reqObj = {
      [this.data.model?.category]: {
        [this.data.model?.documentName]: { ...documentData }
      }
    }
    if (this.documentData && this.documentData[this.data.model?.category]) {
      reqObj[this.data.model?.category] = Object.assign(this.documentData[this.data.model?.category], reqObj[this.data.model?.category])
    }

    this.updateByIdDocument(reqObj, this.data?.model?.id);
  }

  updateByIdDocument(data: any, id: string) {
    this.apiHelper.updateData("user-documents", id, data).subscribe((single) => {
      this.apiHelper.openSnackBar("Removed document successfully");
    })
  }

  downloadDocument(url: string) {
    let result = "";
    if (url && url.indexOf("com/") > 0) {
      const [, pathVariable] = url.split("com/");
      const [folderName, fileName] = pathVariable.split("/");
      this.spinner.show();
      this.apiHelper.generateSignedUrl(folderName, fileName)
        .subscribe(({ signedUrl }: { signedUrl: string }) => {
          this.spinner.hide();
          result = signedUrl;

          window.open(signedUrl, '_blank')
        },
          error => {
            this.spinner.hide();
          });
    }
  }

  clearDetails() {
    this.loanService.setDefaultDetails();
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  checkStatus() {
    this.modalService.dismissAll()
    if (this.isPartnerLink) {
      this.route.navigate(['/application-status' + this.loanService?.partnerDetails?.uid])
      return;
    }
    this.route.navigate(['/application-status'])
  }
  getFileNameFromS3Path(s3Path: any) {
    const filenameWithExtension = s3Path.split('/').pop();
    const filenameWithoutNumbers = filenameWithExtension.replace(/[0-9]/g, '');
    const fileNamewithoutSpecial=filenameWithoutNumbers.replace(/[^a-zA-Z. ]/g, "")
    if (fileNamewithoutSpecial === "") {
      return "default";
    }
    if (fileNamewithoutSpecial?.length > 10) {
      return `${fileNamewithoutSpecial.slice(0, 10) + "..."}`
    }
    else {
      return fileNamewithoutSpecial;
    }
  }

  findHeadingList(category: string) {
    const data = this.headingList.filter((single: any) => single.category.includes(category));
    return data;

  }
}